import { atomWithStorage } from 'jotai/utils'
import { STORAGE_KEY_NAME } from '../constants'

type IThemeState = boolean

const storageKey: string = `${STORAGE_KEY_NAME}/isThemeDark`
const defaultState: IThemeState = false

// Set the string key and the initial value
export const themeIsDarkAtom = atomWithStorage<IThemeState>(
	storageKey,
	defaultState,
	undefined,
	{
		getOnInit: true // If the stored value is preferred set getOnInit to true
	}
)

// smth like 'action-creators' from redux
export const turnDarkTheme = (currVal: IThemeState) => true
export const turnLightTheme = (currVal: IThemeState) => false

export const toggleTheme = (currVal: IThemeState) => !currVal